<template>
  <div class="max-w-[400px] mx-auto px-10">
    <h3 class="scroll-m-20 text-2xl font-semibold tracking-tight py-5">
      
    
      <img src="public/images/logos/superseeded_logo_small.png" alt="SuperSeeded" class="max-w-[120px] my-4" />
      Create an account
    </h3>
    <AccountRegister :useSocialLogin="false" />
    <nuxt-link to="/login" class="flex justify-center items-center">
      <Button variant="ghost" class="whitespace-nowrap">
        <span class="underline text-sm whitespace-nowrap">Sign In</span>
        <Icon name="material-symbols:arrow-left-alt-rounded" size="20" class="mx-3" />
        If you already have an account

      </Button>
    </nuxt-link>
  </div>
</template>

<script setup lang="ts" >
import { NuxtImg } from '#components';


const user = useSupabaseUser()


watchEffect(async () => {
  if (user.value) {
    await navigateTo('/confirm')
  }
});

defineOgImageComponent('NuxtSeo', {
    title: 'SuperSeeded.ai',
    description: '',
    theme: '#c8c9d0',
    colorMode: 'light',
})


  definePageMeta({
      layout: "auth",
  })






</script>
